export const scrollbarTheme = {
  bg: 'palette.transparent',
  borderColor: 'palette.transparent',
  borderRadius: '10px',
  borderWidth: '4px',
  separatorColor: 'palette.transparent',
  thumb: 'palette.surface.4',
  width: '14px',
};
